import { NavLink, Outlet, useResolvedPath } from "react-router-dom";
import { useState, useEffect } from "react";

const AnimalResultsLayout = ({animalThemesData}) => {
    const url = useResolvedPath("").pathname;

    // State variable for themes navigation banner
    const [priorityThemes, setPriorityThemes] = useState([]);

    useEffect(() => {
      const getPriorityThemes = () => {
        const themesWithPriorityOne = animalThemesData.filter((theme) => theme.priority === '1');
        setPriorityThemes(themesWithPriorityOne);
      };

      if (animalThemesData.length > 0) {
        getPriorityThemes();
      }
    }, [animalThemesData]);

  return (
    <div className="bg-black">

      <div className="container bg-black flex justify-center mx-auto py-5">
        <nav className="flex flex-wrap xl:flex-nowrap gap-2 xl:gap-4 justify-center xl:justify-start text-sm md:text-lg">
          <NavLink className="bg-black text-white border-2 border-white text-center p-1 rounded-md hover:bg-white hover:text-black" to={`${url}`} end>
            All
          </NavLink>
        {priorityThemes.map((theme) => (
          <NavLink className="bg-black text-white border-2 border-white text-center p-1 rounded-md hover:bg-white hover:text-black transition-all" to={`${url}/${theme.url}`} key={theme.theme_name} >
            <p>{theme.theme_name}</p>
          </NavLink>
        ))}
        </nav>
      </div>

      <Outlet />
    </div>
  );
};

export default AnimalResultsLayout;
